export default __webpack_public_path__ + "static/media/time.1d8d18d1.svg";